import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './locales/en.json';
import ru from './locales/ru.json';
import uk from './locales/uk.json';

export const LOCALES = ['uk', 'ru', 'en'] as const;
export type Locale = (typeof LOCALES)[number];
/** Short labels shown in the UI switch; "UA" is the customary label on Ukrainian sites. */
export const LOCALE_LABEL: Record<Locale, string> = { uk: 'UA', ru: 'RU', en: 'EN' };
export const LOCALE_NAME: Record<Locale, string> = { uk: 'Українська', ru: 'Русский', en: 'English' };

/** Browser language if it is uk / ru / en, otherwise English. */
export function detectLocale(): Locale {
  const nav = (typeof navigator !== 'undefined' ? navigator.language : 'en').slice(0, 2);
  return (LOCALES as readonly string[]).includes(nav) ? (nav as Locale) : 'en';
}

void i18n.use(initReactI18next).init({
  resources: { en: { translation: en }, ru: { translation: ru }, uk: { translation: uk } },
  lng: 'en',
  fallbackLng: 'en',
  interpolation: { escapeValue: false },
  returnNull: false,
});

export default i18n;
